export type Lang = "en" | "es";

export const DICT = {
  en: {
    // ---------- nav / topbar ----------
    nav_explore: "Explore",
    nav_club: "The Club",
    nav_field: "Journal",
    wm_sup: "VLC · Est. 24",
    signin: "Sign in",

    // ---------- hero plates ----------
    plate_tl: "Bougie Travel Club, S.L.",
    plate_tc: "Volume IV · Spring 2026",
    plate_tr: "Valencia, España",
    plate_bl: "A film about a long lunch",
    plate_bc: "Runtime · 5 nights",
    plate_br: "Premium small-group travel",

    // ---------- hero ----------
    hero_kicker: "A Bougie Production",
    hero_h1_l1: "A long",
    hero_h1_l2: "lunch,",
    hero_h1_l3: "somewhere",
    hero_h1_l4: "else.",
    hero_deck:
      "A members' travel house for expats in Valencia. Small buses, smaller groups, restaurants the guidebooks haven't found yet — and a Sunday you don't have to plan.",
    hero_cta1: "Get started",
    hero_cta2: "Explore trips",

    // ---------- peek strip ----------
    peek_l: "Scroll · Reel 02",
    peek_c: "Now showing",
    peek_r: "14 of 26 booked",

    // ---------- megamenu ----------
    mega_cal: "2026 Calendar",
    mega_per: "By Group",
    meta_private_count: "By inquiry",
    mega_feature_kicker: "Now booking · Spring '26",
    mega_feature_title: "Almendros",
    mega_feature_p:
      "Five nights between Ronda and Granada, with a private dinner at a working olive estate.",
    mega_feature_cta: "Read the dossier",

    // ---------- Now Showing (personas) ----------
    ns_no: "Reel 02 — Cast",
    ns_t1: "Four kinds ",
    ns_t2: "of traveler.",
    ns_meta: "Pick the energy. We staff, plan, drive, and feed the rest.",
    pc_w_title: "Girls' Trips.",
    pc_m_title: "Bro-cations.",
    pc_x_title: "Mixed Groups.",
    pc_p_title: "Private Trips.",
    focus_tag: "Now in spotlight ↓",
    focus_tag_idle: "Spotlight this →",

    // ---------- Why ----------
    why_kicker: "Reel 03 — Why Bougie",
    why_t1: "Why travel ",
    why_t2: "with us.",
    why_meta: "Four small things that change the whole weekend.",
    why1_t1: "We actually ",
    why1_t2: "live here.",
    why1_p:
      "Born in Valencia, raised between Catalonia and Madrid. We pick the restaurant, the route, the wine — and we usually know the owner's mother.",
    why2_t1: "Smaller buses, ",
    why2_t2: "smaller groups.",
    why2_p:
      "Fourteen-seat vans, eight to twelve guests. Quiet roads, faster pickups, real conversation at dinner. No name-tags.",
    why3_t1: "The price is ",
    why3_t2: "the price.",
    why3_p:
      "All-in: rooms, transport, meals, wine list, welcome kit, host time. No optional upsells, no surprise tabs at checkout.",
    why4_t1: "You meet ",
    why4_t2: "your people.",
    why4_p:
      "Most travelers book their second trip with someone from their first. The Bougie Club WhatsApp is louder than the calendar.",

    // ---------- Spotlight ----------
    spot_kicker: "Reel 04",
    spot_section_t1: "Featured ",
    spot_section_t2: "Trips.",
    spot_cta: "Read the dossier",
    spot_pick_lbl: "Or pick another traveler →",
    tab_w: "Girls' Trips",
    tab_m: "Bro-cations",
    tab_x: "Mixed Groups",
    tab_p: "Private Trips",
    sb_meta_w: "12 departures · 2026",
    sb_meta_m: "8 departures · 2026",
    sb_meta_x: "14 departures · 2026",
    sb_meta_p: "By inquiry · 2026",

    // ---------- Offers (live from HighLevel Products) ----------
    offers_t1: "Open ",
    offers_t2: "departures.",
    offers_meta: "Pulled live from our HighLevel catalogue.",
    offers_empty: "No open departures right now. Check back soon.",
    offers_loading: "Loading…",
    offers_cta: "Reserve a seat",

    // ---------- Where to start ----------
    wts_kicker: "Reel 05 — Where to start",
    wts_t1: "Three ways ",
    wts_t2: "in.",
    wts_meta: "Pick the door you're closest to. We'll meet you on the other side.",
    wts1_t1: "Take the ",
    wts1_t2: "trip-finder.",
    wts1_p:
      "Five questions, one recommendation. Ninety seconds. The host who'll be on the trip writes back the same day.",
    wts1_cta: "Start the quiz",
    wts2_t1: "Browse the ",
    wts2_t2: "calendar.",
    wts2_p:
      "Twenty-six departures, March through December. Filter by month or by group. Most fill in under a fortnight.",
    wts2_cta: "See the calendar",
    wts3_t1: "Plan a ",
    wts3_t2: "private trip.",
    wts3_p:
      "Your eight. Tell us when and roughly what, and we'll send a written dossier — villa, chef, route, wine list — within 48 hours.",
    wts3_cta: "Make an inquiry",

    // ---------- Club ----------
    club_ks: "Membership · Reel 06",
    club_m1: "Bougie ",
    club_m2: "Club",
    club_b1:
      "An annual membership for the people who travel with us more than once a year. ",
    club_b2: "No commission, calendar first, first call on private dates.",
    club_cta: "Learn more",
    perk1_h1: "No ",
    perk1_h2: "commission.",
    perk1_p: "We waive the 6% booking fee on every Bougie departure, every year.",
    perk2_h1: "Calendar ",
    perk2_h2: "first.",
    perk2_p:
      "Members see the next year's calendar 30 days before anyone else does.",
    perk3_h1: "First ",
    perk3_h2: "call.",
    perk3_p: "When a private week opens up, the members' list rings first.",
    perk4_h1: "Priority ",
    perk4_h2: "waitlist.",
    perk4_p:
      "Trips fill in a fortnight. Members move to the top of the list, automatically.",

    // ---------- Testimony ----------
    t_no: "Reel 07 — From the travellers",
    t_t1: "From those ",
    t_t2: "who left home.",
    t1_q1:
      "I'm 47, single, new to Valencia, and I do not need to make friends in a hostel. ",
    t1_q2: "Bougie solved a problem I didn't know had a name.",
    t1_who: "Toronto → Ruzafa · 3 trips",
    t2_q1:
      "My wife and I joined the Club after one mixed weekend in Mallorca. ",
    t2_q2: "We've stopped planning trips entirely.",
    t2_who: "Munich → El Carmen · Club '25",
    t3_q1: "Booked a private week for my mother's 70th. ",
    t3_q2: "They handled my eight cousins better than I do.",
    t3_who: "Buenos Aires → Valencia · Private",

    // ---------- Closing ----------
    closing_k: "Coming soon · Spring 2026",
    closing_t1: "Stop ",
    closing_t2: "planning.",
    closing_p:
      "Once a month, the next quarter's calendar, a long lunch worth flying for, and not much else.",
    closing_cta1: "Get started",
    closing_cta2: "Explore trips",

    // ---------- Footer ----------
    foot_blurb:
      "A members' travel house in Valencia. Small buses, smaller groups, no commission to members.",
    foot_h1: "Travel with us",
    foot_l1: "2026 Calendar",
    foot_l2: "All-Women",
    foot_l3: "All-Men",
    foot_l4: "Mixed Groups",
    foot_l5: "Private",
    foot_h2: "The Club",
    foot_l6: "Membership",
    foot_l7: "Early access",
    foot_l8: "Member dinners",
    foot_l9: "Sign in",
    foot_h4: "Fine print",
    foot_l14: "Cancellations",
    foot_l15: "Insurance",
    foot_l16: "Terms",
    foot_l17: "Privacy",
    foot_sub_h: "A letter, once a month.",
    foot_sub_p:
      "Next quarter's calendar, a long lunch worth flying for, and not much else.",
    foot_sub_ph: "name@household.com",
    foot_sub_btn: "Subscribe",
    foot_sub_fine: "Members get it first.",
    foot_sub_ok: "On the list. Members get it first.",
    foot_sub_err: "Something snagged. Try again?",
    foot_reg: "Registered tour operator · CV-Mm-1234-V",

    // ---------- Trip detail page ----------
    trip_back: "Back to all trips",
    trip_load_err: "Couldn't load this trip. Try again in a moment.",
    trip_not_found: "We can't find that trip.",
    trip_eyebrow: "A Bougie Travel Club departure",
    trip_price_label: "All inclusive",
    trip_duration_value: "1 day",
    trip_duration_label: "Duration",
    trip_group_value: "12 max",
    trip_group_label: "Group size",
    trip_cta_primary: "Reserve your seat",
    trip_secnav_aria: "Trip sections",
    trip_sec_welcome: "Welcome",
    trip_sec_love: "Highlights",
    trip_sec_day: "Day by day",
    trip_sec_notes: "Trip notes",
    trip_sec_gallery: "Gallery",
    trip_sec_faq: "FAQ",

    trip_welcome_t1: "Welcome to",
    trip_love_t1: "What you'll ",
    trip_love_t2: "love.",
    trip_love_1_t: "Local hosts",
    trip_love_1_p: "Run by someone who actually lives here and knows the streets, the chefs, the side roads.",
    trip_love_2_t: "Small groups",
    trip_love_2_p: "Eight to twelve travelers max. Real conversation at lunch, no name tags, no scripts.",
    trip_love_3_t: "All-in pricing",
    trip_love_3_p: "Transport, restaurants, host time, welcome kit. Nothing surprises you at the end.",
    trip_love_4_t: "Bilingual",
    trip_love_4_p: "Hosted in English and Spanish; we switch fluidly so nobody's lost in translation.",

    trip_day_t1: "Day by ",
    trip_day_t2: "day.",
    trip_day_label: "Day",
    trip_day_1_t: "Pickup & arrival",
    trip_day_1_p: "Comfortable bus pickup from central Valencia. We're on the road by 8:30, with coffee and a thoughtful welcome pack.",
    trip_day_2_t: "Morning exploration",
    trip_day_2_p: "Guided wander through the old town with a local who knows the artisan shops most guidebooks miss.",
    trip_day_3_t: "Long lunch",
    trip_day_3_p: "Lunch at a restaurant we've been working with for years. Local wines, the menu the family actually eats.",
    trip_day_4_t: "Afternoon adventure",
    trip_day_4_p: "Whether it's a hidden cove, a hike to a viewpoint, or a quiet museum — the best part of the day, picked carefully.",
    trip_day_5_t: "Sunset return",
    trip_day_5_p: "Slow return to Valencia, golden hour out the window. Back in time for dinner with your new people.",
    trip_day_foot: "Itinerary subject to weather and the rhythm of the day — we'd rather adjust than rush.",

    trip_notes_t1: "Trip ",
    trip_notes_t2: "notes.",
    trip_notes_in_t: "What's included",
    trip_notes_in_1: "Round-trip transport in a comfortable 14-seat van",
    trip_notes_in_2: "All meals during the trip, with wine",
    trip_notes_in_3: "Welcome kit (water, snacks, a small Bougie gift)",
    trip_notes_in_4: "Bilingual local host with you the whole day",
    trip_notes_in_5: "Entry fees to any included sites",
    trip_notes_out_t: "What's not included",
    trip_notes_out_1: "Personal souvenirs and extras",
    trip_notes_out_2: "Travel insurance (optional add-on)",
    trip_notes_out_3: "Anything not listed above",

    trip_gallery_t1: "From the ",
    trip_gallery_t2: "trip.",

    trip_faq_t1: "Common ",
    trip_faq_t2: "questions.",
    trip_faq_1_q: "Who is this trip for?",
    trip_faq_1_a: "Expats and travelers in Valencia who want a curated day out without planning anything. Most guests are 30s–60s; conversations switch easily between Spanish and English.",
    trip_faq_2_q: "How fit do I need to be?",
    trip_faq_2_a: "Comfortable walking on uneven ground is enough. We're not running marathons — we're enjoying a place, slowly.",
    trip_faq_3_q: "Can I bring my partner / a friend?",
    trip_faq_3_a: "Yes — book as many seats as you need. Private full-bus bookings are also available; ask us.",
    trip_faq_4_q: "What if it rains?",
    trip_faq_4_a: "We always have a wet-weather plan and we travel year-round. If a trip's not safe to run, we reschedule or refund — your choice.",

    trip_inq_t1: "Ask about ",
    trip_inq_deck: "Tell us when you'd like to go (or what you'd like to know) and your host responds today with available dates, details, and how to hold a seat. Not a newsletter — a one-to-one reply.",
    trip_inq_email_ph: "Your email",
    trip_inq_note_ph: "Dates you have in mind, group size, anything specific…",
    trip_inq_btn: "Talk to a host",
    trip_form_ok: "Got it. Your host writes back today.",

    // ---------- Trip detail sidebar ----------
    trip_side_title: "Trip details",
    trip_side_from: "From",
    trip_side_duration: "Duration",
    trip_side_group: "Group size",
    trip_side_departs: "Departs from",
    trip_side_departs_value: "Central Valencia",
    trip_side_languages: "Languages",
    trip_side_languages_value: "English & Spanish",
    trip_side_inclusive: "Pricing",
    trip_side_inclusive_value: "All-in, no extras",
    trip_side_book_cta: "Book this trip",
    trip_side_book_sub: "Questions first? Talk to your host →",
    trip_side_seats: "Limited seats",
    trip_side_seats_value: "Most fill in 2 weeks",
  },
  es: {
    nav_explore: "Explorar",
    nav_club: "El Club",
    nav_field: "Diario",
    wm_sup: "VLC · Desde 24",
    signin: "Acceder",

    plate_tl: "Bougie Travel Club, S.L.",
    plate_tc: "Volumen IV · Primavera 2026",
    plate_tr: "Valencia, España",
    plate_bl: "Una película sobre una comida larga",
    plate_bc: "Duración · 5 noches",
    plate_br: "Viajes premium en grupo pequeño",

    hero_kicker: "Una producción de Bougie",
    hero_h1_l1: "Una",
    hero_h1_l2: "comida",
    hero_h1_l3: "en otra",
    hero_h1_l4: "parte.",
    hero_deck:
      "Una casa de viaje, con socios, para expats en Valencia. Furgones pequeños, grupos más pequeños, restaurantes que no aparecen aún en las guías, y un domingo que no tienes que planificar.",
    hero_cta1: "Empezar",
    hero_cta2: "Ver viajes",

    peek_l: "Sigue · Rollo 02",
    peek_c: "En cartel",
    peek_r: "14 de 26 reservados",

    mega_cal: "Calendario 2026",
    mega_per: "Por grupo",
    meta_private_count: "Bajo consulta",
    mega_feature_kicker: "Reservas abiertas · Primavera '26",
    mega_feature_title: "Almendros",
    mega_feature_p:
      "Cinco noches entre Ronda y Granada, con cena privada en una almazara en activo.",
    mega_feature_cta: "Leer el dossier",

    ns_no: "Rollo 02 — Reparto",
    ns_t1: "Cuatro tipos ",
    ns_t2: "de viajero.",
    ns_meta:
      "Elige la energía. Nos ocupamos del equipo, el plan, la furgoneta y la mesa.",
    pc_w_title: "Viajes de Chicas.",
    pc_m_title: "Bro-cations.",
    pc_x_title: "Grupos Mixtos.",
    pc_p_title: "Viajes Privados.",
    focus_tag: "En foco ahora ↓",
    focus_tag_idle: "Llevar al foco →",

    why_kicker: "Rollo 03 — Por qué Bougie",
    why_t1: "Por qué viajar ",
    why_t2: "con nosotros.",
    why_meta: "Cuatro pequeñas cosas que cambian todo el finde.",
    why1_t1: "De verdad ",
    why1_t2: "vivimos aquí.",
    why1_p:
      "Nacidas en Valencia, criadas entre Cataluña y Madrid. Elegimos el restaurante, la ruta y el vino — y normalmente conocemos a la madre del dueño.",
    why2_t1: "Furgones pequeños, ",
    why2_t2: "grupos más pequeños.",
    why2_p:
      "Catorce plazas, de ocho a doce comensales. Carreteras tranquilas, recogidas rápidas, conversaciones reales en la mesa. Sin tarjetas con nombres.",
    why3_t1: "El precio es ",
    why3_t2: "el precio.",
    why3_p:
      "Todo incluido: habitaciones, transporte, comidas, carta de vinos, kit de bienvenida, tiempo de la anfitriona. Sin extras opcionales, sin sustos al final.",
    why4_t1: "Conoces a ",
    why4_t2: "tu gente.",
    why4_p:
      "La mayoría de viajeros reservan su segundo viaje con alguien del primero. El WhatsApp del Bougie Club suena más que el calendario.",

    spot_kicker: "Rollo 04",
    spot_section_t1: "Viajes ",
    spot_section_t2: "destacados.",
    spot_cta: "Leer el dossier",
    spot_pick_lbl: "O elige otro viajero →",
    tab_w: "Viajes Chicas",
    tab_m: "Bro-cations",
    tab_x: "Grupos Mixtos",
    tab_p: "Viajes Privados",
    sb_meta_w: "12 salidas · 2026",
    sb_meta_m: "8 salidas · 2026",
    sb_meta_x: "14 salidas · 2026",
    sb_meta_p: "Bajo consulta · 2026",

    offers_t1: "Salidas ",
    offers_t2: "abiertas.",
    offers_meta: "En vivo desde nuestro catálogo HighLevel.",
    offers_empty: "No hay salidas abiertas ahora mismo. Vuelve pronto.",
    offers_loading: "Cargando…",
    offers_cta: "Reservar plaza",

    wts_kicker: "Rollo 05 — Por dónde empezar",
    wts_t1: "Tres puertas ",
    wts_t2: "de entrada.",
    wts_meta: "Elige la que tienes más cerca. Te esperamos al otro lado.",
    wts1_t1: "Haz el ",
    wts1_t2: "trip-finder.",
    wts1_p:
      "Cinco preguntas, una recomendación. Noventa segundos. La anfitriona del viaje te responde el mismo día.",
    wts1_cta: "Empezar el quiz",
    wts2_t1: "Mira el ",
    wts2_t2: "calendario.",
    wts2_p:
      "Veintiséis salidas, de marzo a diciembre. Filtra por mes o por grupo. La mayoría llenan en menos de quince días.",
    wts2_cta: "Ver calendario",
    wts3_t1: "Planifica un ",
    wts3_t2: "viaje privado.",
    wts3_p:
      "Tus ocho. Dinos cuándo y más o menos qué; te enviamos el dossier — villa, chef, ruta, carta — en 48 horas.",
    wts3_cta: "Hacer consulta",

    club_ks: "Membresía · Rollo 06",
    club_m1: "Bougie ",
    club_m2: "Club",
    club_b1:
      "Una cuota anual para quienes viajan con nosotros más de una vez al año. ",
    club_b2: "Sin comisión, calendario primero, primera llamada para fechas privadas.",
    club_cta: "Saber más",
    perk1_h1: "Sin ",
    perk1_h2: "comisión.",
    perk1_p: "Eliminamos la comisión del 6% en cada salida Bougie, cada año.",
    perk2_h1: "Calendario ",
    perk2_h2: "primero.",
    perk2_p:
      "Los socios ven el calendario del próximo año 30 días antes que nadie.",
    perk3_h1: "Primera ",
    perk3_h2: "llamada.",
    perk3_p: "Cuando se abre una semana privada, la lista de socios suena primero.",
    perk4_h1: "Lista ",
    perk4_h2: "prioritaria.",
    perk4_p:
      "Los viajes llenan en quince días. Los socios suben al inicio de la lista, automáticamente.",

    t_no: "Rollo 07 — Quienes han viajado",
    t_t1: "De quienes ",
    t_t2: "se fueron de casa.",
    t1_q1:
      "Tengo 47, soltera, nueva en Valencia, y no necesito hacer amigos en un albergue. ",
    t1_q2: "Bougie resolvió un problema que no sabía que tenía nombre.",
    t1_who: "Toronto → Ruzafa · 3 viajes",
    t2_q1: "Mi mujer y yo nos hicimos socios tras un finde mixto en Mallorca. ",
    t2_q2: "Hemos dejado de planificar por nuestra cuenta.",
    t2_who: "Múnich → El Carmen · Socios '25",
    t3_q1: "Reservé una semana privada para los 70 de mi madre. ",
    t3_q2: "Manejaron a mis ocho primos mejor que yo.",
    t3_who: "Buenos Aires → Valencia · Privado",

    closing_k: "Pronto · Primavera 2026",
    closing_t1: "Deja de ",
    closing_t2: "planificar.",
    closing_p:
      "Una vez al mes, el calendario del próximo trimestre, una comida larga por la que merece volar y poco más.",
    closing_cta1: "Empezar",
    closing_cta2: "Ver viajes",

    foot_blurb:
      "Una casa de viaje, con socios, en Valencia. Furgones pequeños, grupos más pequeños, sin comisión para socios.",
    foot_h1: "Viaja con nosotros",
    foot_l1: "Calendario 2026",
    foot_l2: "Solo Mujeres",
    foot_l3: "Solo Hombres",
    foot_l4: "Grupos Mixtos",
    foot_l5: "Privados",
    foot_h2: "El Club",
    foot_l6: "Membresía",
    foot_l7: "Acceso anticipado",
    foot_l8: "Cenas de socios",
    foot_l9: "Acceder",
    foot_h4: "Letra pequeña",
    foot_l14: "Cancelaciones",
    foot_l15: "Seguros",
    foot_l16: "Términos",
    foot_l17: "Privacidad",
    foot_sub_h: "Una carta, una vez al mes.",
    foot_sub_p:
      "El calendario del próximo trimestre, una comida larga por la que merece volar, y poco más.",
    foot_sub_ph: "nombre@casa.com",
    foot_sub_btn: "Suscribirme",
    foot_sub_fine: "Los socios la reciben primero.",
    foot_sub_ok: "Apuntada. Los socios la reciben primero.",
    foot_sub_err: "Algo se atascó. ¿Lo probamos otra vez?",
    foot_reg: "Operador turístico registrado · CV-Mm-1234-V",

    // ---------- Trip detail page ----------
    trip_back: "Volver a los viajes",
    trip_load_err: "No pudimos cargar este viaje. Inténtalo en un momento.",
    trip_not_found: "No encontramos ese viaje.",
    trip_eyebrow: "Una salida de Bougie Travel Club",
    trip_price_label: "Todo incluido",
    trip_duration_value: "1 día",
    trip_duration_label: "Duración",
    trip_group_value: "12 máx.",
    trip_group_label: "Plazas",
    trip_cta_primary: "Reservar plaza",
    trip_secnav_aria: "Secciones del viaje",
    trip_sec_welcome: "Bienvenida",
    trip_sec_love: "Lo mejor",
    trip_sec_day: "Día a día",
    trip_sec_notes: "Notas",
    trip_sec_gallery: "Galería",
    trip_sec_faq: "Preguntas",

    trip_welcome_t1: "Bienvenida a",
    trip_love_t1: "Lo que vas a ",
    trip_love_t2: "amar.",
    trip_love_1_t: "Anfitriones locales",
    trip_love_1_p: "Lo lleva alguien que vive aquí y conoce las calles, los cocineros y los caminos secundarios.",
    trip_love_2_t: "Grupos pequeños",
    trip_love_2_p: "De ocho a doce viajeros máximo. Conversación real en la mesa, sin tarjetas con nombres ni guiones.",
    trip_love_3_t: "Precio total",
    trip_love_3_p: "Transporte, restaurantes, tiempo del anfitrión, kit de bienvenida. Nada te sorprende al final.",
    trip_love_4_t: "Bilingüe",
    trip_love_4_p: "Conducido en inglés y español; cambiamos con fluidez para que nadie quede fuera.",

    trip_day_t1: "Día ",
    trip_day_t2: "a día.",
    trip_day_label: "Día",
    trip_day_1_t: "Recogida y salida",
    trip_day_1_p: "Recogida en bus en el centro de Valencia. En carretera a las 8:30, con café y un detalle de bienvenida.",
    trip_day_2_t: "Exploración matinal",
    trip_day_2_p: "Paseo guiado por el casco antiguo con alguien local que conoce las tiendas que las guías no encuentran.",
    trip_day_3_t: "Comida larga",
    trip_day_3_p: "Comida en un restaurante con el que llevamos años trabajando. Vinos locales, el menú que come la familia.",
    trip_day_4_t: "Aventura de tarde",
    trip_day_4_p: "Sea una cala escondida, un paseo a un mirador o un museo tranquilo — la mejor parte del día, elegida con cariño.",
    trip_day_5_t: "Regreso al atardecer",
    trip_day_5_p: "Vuelta tranquila a Valencia con la luz dorada por la ventana. Llegas a tiempo para cenar con tu nueva gente.",
    trip_day_foot: "Itinerario sujeto al tiempo y al ritmo del día — preferimos ajustar que correr.",

    trip_notes_t1: "Notas del ",
    trip_notes_t2: "viaje.",
    trip_notes_in_t: "Lo que está incluido",
    trip_notes_in_1: "Transporte de ida y vuelta en furgoneta de 14 plazas",
    trip_notes_in_2: "Todas las comidas durante el viaje, con vino",
    trip_notes_in_3: "Kit de bienvenida (agua, snacks, un detalle de Bougie)",
    trip_notes_in_4: "Anfitrión local bilingüe contigo durante todo el día",
    trip_notes_in_5: "Entradas a los sitios incluidos",
    trip_notes_out_t: "Lo que no está incluido",
    trip_notes_out_1: "Recuerdos personales y extras",
    trip_notes_out_2: "Seguro de viaje (opcional)",
    trip_notes_out_3: "Cualquier cosa no listada arriba",

    trip_gallery_t1: "Desde el ",
    trip_gallery_t2: "viaje.",

    trip_faq_t1: "Preguntas ",
    trip_faq_t2: "frecuentes.",
    trip_faq_1_q: "¿Para quién es este viaje?",
    trip_faq_1_a: "Para expats y viajeros en Valencia que quieren un día curado sin tener que planificar nada. La mayoría son de 30 a 60; las conversaciones fluyen entre español e inglés.",
    trip_faq_2_q: "¿Qué condición física necesito?",
    trip_faq_2_a: "Basta con caminar cómodamente por suelo irregular. No corremos maratones — disfrutamos un lugar, despacio.",
    trip_faq_3_q: "¿Puedo traer a mi pareja / a un amigo?",
    trip_faq_3_a: "Sí — reserva las plazas que necesites. También hacemos reservas privadas de bus entero; pregúntanos.",
    trip_faq_4_q: "¿Y si llueve?",
    trip_faq_4_a: "Siempre tenemos plan B y viajamos todo el año. Si un viaje no se puede hacer con seguridad, lo reprogramamos o lo reembolsamos — tú decides.",

    trip_inq_t1: "Pregunta sobre ",
    trip_inq_deck: "Cuéntanos cuándo te gustaría ir (o qué quieres saber) y tu anfitrión responde hoy mismo con fechas, detalles y cómo guardar plaza. No es un boletín — es una respuesta uno a uno.",
    trip_inq_email_ph: "Tu correo",
    trip_inq_note_ph: "Fechas que tienes en mente, tamaño del grupo, lo que quieras…",
    trip_inq_btn: "Hablar con un anfitrión",
    trip_form_ok: "Recibido. Tu anfitrión responde hoy mismo.",

    // ---------- Trip detail sidebar ----------
    trip_side_title: "Detalles del viaje",
    trip_side_from: "Desde",
    trip_side_duration: "Duración",
    trip_side_group: "Plazas",
    trip_side_departs: "Salida desde",
    trip_side_departs_value: "Valencia centro",
    trip_side_languages: "Idiomas",
    trip_side_languages_value: "Inglés y español",
    trip_side_inclusive: "Precio",
    trip_side_inclusive_value: "Todo incluido",
    trip_side_book_cta: "Reservar este viaje",
    trip_side_book_sub: "¿Dudas? Habla con tu anfitrión →",
    trip_side_seats: "Plazas limitadas",
    trip_side_seats_value: "Suelen llenarse en 2 semanas",
  },
} satisfies Record<Lang, Record<string, string>>;

export type DictKey = keyof typeof DICT["en"];
